import { Routes, Route } from 'react-router'
import NotFound from './Pages/Base/NotFound'
import Layout from './Components/Layout'
import Media from './Pages/Media'
import CaseStudy from './Pages/WebAdmin/CaseStudies/CaseStudy'
import WebAdmin from './Pages/WebAdmin'
import CaseStudies from './Pages/WebAdmin/CaseStudies'
import Blog from './Pages/WebAdmin/Blog'
import GitHub from './Pages/GitHub'
import Survey from './Pages/Survey'
import Surveys from './Pages/Survey/Surveys'
import Profile from './Pages/User/Profile'
import Clients from './Pages/Clients'
import Home from './Pages/Base/Home'
import { CheckAuth } from './utils/Hoc/CheckAuth'
import Login from './Pages/Auth/Login'
import Register from './Pages/Auth/Register'
import { Client } from './Pages/Clients/Client'

const Router = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="login" element={<Login />} />
        <Route path="sign-up" element={<Register />} />
        <Route element={<CheckAuth />}>
          <Route index element={<Home />} />
          <Route path="clients" element={<Clients />} />
          <Route path="clients/:id" element={<Client />} />
          {/* <Route path="bug-tracker" element={<BugTracker />} /> */}
          {/* <Route path="bug-tracker/:id" element={<BugReport />} /> */}
          <Route path="profile" element={<Profile />} />
          <Route path="surveys" element={<Surveys />} />
          <Route path="surveys/:id" element={<Survey />} />

          {/* <Route path="optimize" element={<ContainersPage />} />
        <Route path="optimize/:id/experiments" element={<ExperimentsPage />} />
        <Route path="optimize/:id/experiments/:exp" element={<ExperimentPage />} /> */}
          <Route path="github" element={<GitHub />} />
          <Route path="site-admin" element={<WebAdmin />}>
            <Route path="case-studies" element={<CaseStudies />} />
            <Route path="blog" element={<Blog />} />
          </Route>
          <Route path="site-admin/case-studies/:id" element={<CaseStudy />} />
          <Route path="media" element={<Media />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}

export default Router
